import { createReducer } from 'redux-create-reducer';

const dirtyReducer = createReducer(false, {});

export default dirtyReducer;

export const getIsDirty = state => state.dirty;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/organize/reducers/dirty.js